import React from "react";

const ProgressModal = ({ visible, progressValue, message }) => {
  if (!visible) return null;

  return (
    <div className="modal modal-blur custom-modal fade show" tabIndex="-1" style={{ display: "block" }} aria-labelledby="modalLabel" aria-hidden="false">
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-body">
            <div className="d-flex justify-content-center align-items-center mb-3" style={{ minHeight: "120px" }}>
              <div aria-label="Orange and tan hamster running in a metal wheel" role="img" className="wheel-and-hamster">
                <div className="wheel"></div>
                <div className="hamster">
                  <div className="hamster__body">
                    <div className="hamster__head">
                      <div className="hamster__ear"></div>
                      <div className="hamster__eye"></div>
                      <div className="hamster__nose"></div>
                    </div>
                    <div className="hamster__limb hamster__limb--fr"></div>
                    <div className="hamster__limb hamster__limb--fl"></div>
                    <div className="hamster__limb hamster__limb--br"></div>
                    <div className="hamster__limb hamster__limb--bl"></div>
                    <div className="hamster__tail"></div>
                  </div>
                </div>
                <div className="spoke"></div>
              </div>
            </div>

            <div className="progress" style={{ height: "1.5rem" }}>
              <div className="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" style={{ width: `${progressValue}%` }} aria-valuenow={progressValue} aria-valuemin="0" aria-valuemax="100">
                {progressValue}%
              </div>
            </div>

            <p className="mt-3 text-center">{message}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProgressModal;
